/**
 * Generic fetch -- API Calling Async functions.
 *
 * @return {object}         Promise object
 */
import * as moment from "moment";
const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const headersWithToken = {
  Accept: "application/json",
  "Content-Type": "application/json",
  token: "dae1665d-c4eb-4a4c-9a37-f4f3d52bcf36",
};

async function doFetch(url, options, __showLoading = true) {
  //debugger;
  try {
    options.timeout = 10000;
    let response = await fetch(url, options);
    let responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.log(
      "doctorDetails  doFetch responseJson erreo",
      JSON.stringify(error)
    );
    return error;
  }
}

// Main Fetch Function
function doFetchx(url, options) {
  return fetch(url, options)
    .then((response) => response.json())
    .catch((error) => {
      console.log("doctorDetails  doFetch ", JSON.stringify(error));
      console.log("From Utils", error);
    });
}
export function formatDateForCard(dt) {
  //debugger;
  var d = moment(dt);
  const weekday = new Array("Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var date = d.format("DD");
  var month = monthNames[d.month()];
  var day = weekday[d.day()];
  var dateStr = day + ", " + date + " " + month;
  return dateStr;
}
/*
 * Generic get for rest
 */
export async function asyncGet(
  url,
  needToken = false,
  tokenValue,
  useHeader = true,
  __showLoading = true
) {
  const hdr = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "6024",
  };
  if (global.clientId === 5) hdr.abhakey = "Vpy9jupf3zchHIYQeradW49KQ5Zhfw95";

  if (needToken) {
    hdr.token = tokenValue;
  }
  const options = {};
  options.method = "GET";
  if (useHeader) options.headers = hdr;

  const res = await doFetch(url, options, __showLoading);
  return res;
}
export async function asyncPut(
  url,
  body,
  isJson = true,
  needToken = false,
  tokenValue,
  ContentType = ""
) {
  const options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": ContentType == "" ? "application/json" : ContentType,
    },
    body: isJson ? JSON.stringify(body) : body,
  };
  if (needToken && needToken && needToken != "") {
    options.headers.token = tokenValue;
  }
  const res = await doFetch(url, options);
  return res;
}

export async function asyncDelete(
  url,
  body,
  isJson = true,
  needToken = false,
  tokenValue,
  ContentType = ""
) {
  const options = {
    method: "DELETE",

    headers: {
      Accept: "application/json",
      "Content-Type": ContentType == "" ? "application/json" : ContentType,
      token: needToken ? tokenValue : "",
    },
    body: isJson ? JSON.stringify(body) : body,
  };
  const res = await doFetch(url, options);
  return res;
}
export async function asyncPostImage(
  url,
  body,
  isJson = true,
  needToken = false,
  tokenValue,
  ContentType = "",
  __showLoading = true
) {
  const options = {
    method: "POST",

    headers: {
      "Content-Type": "multipart/form-data",
    },
    body: body,
  };
  if (needToken && needToken && needToken != "") {
    options.headers.token = tokenValue;
  }
  const res = await doFetch(url, options, __showLoading);
  return res;
}
export async function asyncPost(
  url,
  body,
  isJson = true,
  needToken = false,
  tokenValue,
  ContentType = "",
  __showLoading = true
) {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": ContentType == "" ? "application/json" : ContentType,
    },
    body: isJson ? JSON.stringify(body) : body,
  };
  if (needToken && needToken && needToken != "") {
    options.headers.token = tokenValue;
  }
  if (global.clientId === 5)
    options.headers.abhakey = "Vpy9jupf3zchHIYQeradW49KQ5Zhfw95";
  const res = await doFetch(url, options, __showLoading);
  return res;
}

export function doGet(
  url,
  needToken = false,
  tokenValue,
  __showLoading = true
) {
  const options = {
    method: "GET",
    // headers: headersWithToken,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      token: needToken ? tokenValue : "",
    },
  };
  return doFetch(url, options, __showLoading);
}

/*
 * Generic post for rest
 */
export function doPost(
  url,
  body,
  isJson = true,
  needToken = false,
  tokenValue,
  ContentType = "",
  __showLoading = true
) {
  const options = {
    method: "POST",

    headers: {
      Accept: "application/json",
      "Content-Type": ContentType == "" ? "application/json" : ContentType,
      token: needToken ? tokenValue : "",
    },
    body: isJson ? JSON.stringify(body) : body,
  };
  return doFetch(url, options, __showLoading);
}

/*
 * Generic put for rest
 */
export function doPut(url, body, isJson = true, needToken = false, tokenValue) {
  const options = {
    method: "PUT",
    //  headers: headersWithToken,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      token: needToken ? tokenValue : "",
    },
    body: isJson ? JSON.stringify(body) : body,
  };
  return doFetch(url, options);
}

export function doDelete(
  url,
  body,
  isJson = true,
  needToken = false,
  tokenValue,
  ContentType = ""
) {
  const options = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      token: needToken ? tokenValue : "",
    },
    body: isJson ? JSON.stringify(body) : body,
  };
  return doFetch(url, options);
}
